/**
 * Selectors
 */
export const DSP_ACTIVATION_ACTIVATE_PAGE_ID = 'dsp-activation-activate';

/**
 * Translation keys — Admin Settings
 */
export const ADMIN_SETTINGS_HEADER_KEY = 'adsp_settings_header';
export const MANAGER_ACCOUNT_ID_LABEL_KEY = 'manager_account_id_label';
export const MANAGER_ACCOUNT_NAME_LABEL_KEY = 'manager_account_name_label';
export const ENTITY_TYPE_LABEL_KEY = 'adsp_entity_type_label';
export const ENTITY_TYPE_VALUE_KEY = 'enterprise_self_service_label';
export const TIME_ZONE_LABEL_KEY = 'time_zone_label';
export const TIME_ZONE_TOOLTIP_KEY = 'time_zone_tooltip';
export const AASP_LABEL_KEY = 'aasp_label';
export const AASP_CHECKBOX_LABEL_KEY = 'aasp_checkbox_label';
export const PO_NUMBER_LABEL_KEY = 'po_number_label';
export const PO_NUMBER_TOOLTIP_KEY = 'po_number_tooltip';
export const PO_CHECKBOX_LABEL_KEY = 'po_checkbox_label';
export const SELLER_OF_RECORD_LABEL_KEY = 'seller_of_record_label';
export const SELLER_OF_RECORD_TOOLTIP_KEY = 'seller_of_record_tooltip';
export const SHADOW_ENTITY_LABEL_KEY = 'shadow_entity_label';

/**
 * Translation keys — Billing
 */
export const BILLING_HEADER_KEY = 'billing_header';
export const ACCOUNT_MANAGER_ID_LABEL_KEY =
  'account_manager_identification_label';
export const OWNER_LABEL_KEY = 'owner_label';
export const OWNER_DESCRIPTION_KEY = 'owner_description';
export const AGENCY_LABEL_KEY = 'agency_label';
export const AGENCY_DESCRIPTION_KEY = 'agency_description';
export const COMPANY_NAME_LABEL_KEY = 'company_name_label';
export const CONTACT_NAME_LABEL_KEY = 'contact_name_label';
export const PRIMARY_EMAIL_LABEL_KEY = 'primary_email_label';
export const PHONE_NUMBER_LABEL_KEY = 'phone_number_label';
export const WEBSITE_LABEL_KEY = 'website_label';
export const BUSINESS_REG_NUMBER_LABEL_KEY =
  'business_registration_number_label';
export const ADDRESS_LINE_1_LABEL_KEY = 'address_line_1_label';
export const ADDRESS_LINE_2_LABEL_KEY = 'address_line_2_label';
export const POSTAL_CODE_LABEL_KEY = 'postal_code_label';
export const CITY_LABEL_KEY = 'city_label';
export const COUNTRY_LABEL_KEY = 'country_label';
export const STATE_LABEL_KEY = 'state_label';
export const VAT_LABEL_KEY = 'vat_label';
export const VAT_CHECKBOX_LABEL_KEY = 'vat_checkbox_label';
export const VAT_AGREEMENT_LINK_KEY = 'vat_agreement_link';
export const TR_TAX_OFFICE_LABEL_KEY = 'tr_tax_office_label';
export const PRODUCT_TYPE_LABEL_KEY = 'product_type_label';
export const PAYMENT_TERMS_LABEL_KEY = 'payment_terms_label';
export const PAYMENT_30_DAYS_KEY = 'payment_30_days';
export const PAYMENT_45_DAYS_KEY = 'payment_45_days';
export const PAYMENT_60_DAYS_KEY = 'payment_60_days';

/**
 * Translation keys — Page level
 */
export const SELECT_PLACEHOLDER_KEY = 'select_placeholder';
export const OPTIONAL_LABEL_KEY = 'optional_label';
export const REQUIRED_ERROR_KEY = 'required_error';
export const MAX_LENGTH_50_ERROR_KEY = 'max_length_error_50';
export const MAX_LENGTH_60_ERROR_KEY = 'max_length_error_60';
export const MAX_LENGTH_100_ERROR_KEY = 'max_length_error_100';
export const EMAIL_ERROR_KEY = 'email_error';
export const PHONE_ERROR_KEY = 'phone_error';
export const WEBSITE_ERROR_KEY = 'website_error';
export const VAT_ERROR_KEY = 'vat_error';
export const VAT_NOT_APPLICABLE_ERROR_KEY = 'vat_not_applicable_error';
export const SUBMIT_ERROR_KEY = 'submit_error';
export const ALREADY_ACTIVATED_KEY = 'already_activated';
export const GENERIC_ERROR_KEY = 'generic_error';
export const WARNING_BANNER_KEY = 'warning_banner';
export const SNACKBAR_SUCCESS_KEY = 'snackbar_success';
export const SNACKBAR_ENTITY_IDS_KEY = 'snackbar_entity_ids';
